import { Button } from "antd";
import { AddOfferForm } from "components/Forms/AddOfferForm/AddOfferForm";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { useDrawer } from "hooks/useDrawer.ts";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId, FormId } from "types/models.ts";

interface AddOfferDrawerProps {
    onSubmit?: () => void | Promise<void>;
}

export const AddOfferDrawer: FC<AddOfferDrawerProps> = ({ onSubmit }) => {
    const { t } = usePaldockTranslation("drawers.add-offer");
    const { t: tC } = usePaldockTranslation("common");
    const id = DrawerId.AddOffer;
    const formId = FormId.AddOffer;
    const drawerUtils = useDrawer();

    const handleSubmit = async () => {
        await onSubmit?.();
        drawerUtils.hide(id);
    };

    return (
        <Drawer
            drawerId={id}
            title={<DrawerTitle mainTitle={t("title")} />}
            extraButtons={
                <Button size={"large"} htmlType="submit" type={"primary"} form={formId}>
                    {tC("save")}
                </Button>
            }
        >
            <AddOfferForm formId={formId} onFormSubmit={handleSubmit} />
        </Drawer>
    );
};
